import { api } from './ApiService';

export default class PropertyService {
   
    static async get(){
        let response = await api.get(`/property`)
        return response.data
    }
 
}


// WEBPACK FOOTER //
// ./src/service/PropertyService.js